import { HotelCalendarType } from "@website/accommodation-ui/hotel-calendar/hotel-calendar.type";
import { Datepicker } from "@website/ui/datepicker";
import { deepCompare } from "@website/utils/deep-compare";
import { memo } from "react";

const Component = (properties: HotelCalendarType) => {
  const {
    calendarDate,
    onCalendarChange,
    calendarData,
    flatCalendarIntitalShowDates,
    disableLimit,
    disableDates,
    showTitle = false,
    isLabelTop = false
  } = properties;

  return (
    <div>
      {showTitle && (
        <div className="text-subtitle-1 md:text-headline-6 pb-4">
          تقویم و نرخ قیمتی
        </div>
      )}
      <div
        className={`${
          isLabelTop ? "relative" : ""
        } border-outline-thin z-[5] rounded-lg border p-3 md:p-4`}
        id="hotel_calendar"
      >
        <Datepicker
          calendarData={calendarData}
          disableDates={disableDates}
          disableLimit={disableLimit}
          initialShowDates={flatCalendarIntitalShowDates}
          mode="range"
          onChange={onCalendarChange}
          showInstant
          type="flat"
          value={calendarDate}
          isLabelTop={isLabelTop}
        />
      </div>
    </div>
  );
};

export const HotelCalendar = memo(Component, deepCompare);
